import { useEffect, useState } from 'react';

const useProviderFormNavigation = (
  totalSteps: number,
  onStepChange?: (step: number) => void,
) => {
  const [currentStep, setCurrentStep] = useState(1);

  useEffect(() => {
    onStepChange?.(currentStep);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentStep, onStepChange]);

  const goToNextStep = () => setCurrentStep((s) => Math.min(s + 1, totalSteps));
  const goToPrevStep = () => setCurrentStep((s) => Math.max(s - 1, 1));

  return { currentStep, goToNextStep, goToPrevStep };
};

export { useProviderFormNavigation };
